export const languagesWithoutSpaces: string[] = ['zh', 'ja', 'ko'];
